/* RŌZ Hairstylist Choice badge + stylist panel
 * Mount: <div data-proz-choice data-product-handle="milk-styling-mousse" data-src="proz-choice.json" hidden></div>
 * The badge renders only when the product has show_badge = true in the JSON.
 */
(function () {
  var COPY = {
    eyebrow: 'Hairstylist Choice',
    claim: function (n) { return n + ' stylists approve this product'; },
    link: 'View stylists & learn more',
    panelTitle: 'Hairstylist Choice',
    panelIntro: function (n, title) {
      return n + ' professional stylists approve and use ' + title + '.';
    },
    faqs: [
      { q: 'Who are these stylists?',
        a: 'Hairstylists and/or salon owners who approve, use, and love this product from RŌZ hair.' },
      { q: 'What does the badge mean?',
        a: 'It\'s a vote of confidence from professional hairstylists, not just by us. They use this product and they love it.' }
    ],
    footnote: function (d) { return 'Based on stylist posts through ' + d + '.'; }
  };

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  // Only ever link out to https URLs (guards against bad data in the sheet)
  function safeUrl(u) {
    return /^https:\/\//i.test(u || '') ? u : '';
  }

  var ASSET_BASE = '';
  function photoUrl(p) {
    if (!p) return '';
    return /^(https?:)?\/\//.test(p) ? p : ASSET_BASE + p; // bare filename = theme asset
  }

  function avatar(s, size) {
    var wrap = el('span', 'proz-av' + (size ? ' proz-av--' + size : ''));
    wrap.setAttribute('aria-hidden', 'true');
    var fallback = el('span', 'proz-av__initials', s.initials);
    wrap.appendChild(fallback);
    if (s.photo) {
      var img = new Image();
      img.alt = '';
      img.loading = 'lazy';
      img.referrerPolicy = 'no-referrer';
      img.onload = function () { wrap.classList.add('has-img'); };
      img.onerror = function () { img.remove(); };
      img.src = photoUrl(s.photo);
      wrap.appendChild(img);
    }
    return wrap;
  }

  function fmtMonth(iso) {
    var d = new Date(iso + 'T12:00:00');
    return isNaN(d) ? iso : d.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
  }

  function buildBadge(p, open) {
    var card = el('button', 'proz-badge');
    card.type = 'button';
    card.setAttribute('aria-haspopup', 'dialog');
    var faces = el('span', 'proz-badge__faces');
    var byHandle = {};
    p.stylists.forEach(function (s) { byHandle[s.handle] = s; });
    p.faces.forEach(function (h) { if (byHandle[h]) faces.appendChild(avatar(byHandle[h])); });
    var txt = el('span', 'proz-badge__text');
    txt.appendChild(el('span', 'proz-badge__name', COPY.eyebrow));
    txt.appendChild(el('span', 'proz-badge__claim', COPY.claim(p.stylist_count)));
    txt.appendChild(el('span', 'proz-badge__link', COPY.link + ' →'));
    card.appendChild(faces);
    card.appendChild(txt);
    card.addEventListener('click', open);
    return card;
  }

  function buildPanel(p, generated) {
    var dlg = el('dialog', 'proz-panel');
    dlg.setAttribute('aria-labelledby', 'proz-panel-title');
    var inner = el('div', 'proz-panel__inner');

    var head = el('div', 'proz-panel__head');
    var h = el('h2', 'proz-panel__title', COPY.panelTitle);
    h.id = 'proz-panel-title';
    var close = el('button', 'proz-panel__close', '×');
    close.type = 'button';
    close.setAttribute('aria-label', 'Close');
    close.addEventListener('click', function () { dlg.close(); });
    head.appendChild(h);
    head.appendChild(close);
    inner.appendChild(head);

    inner.appendChild(el('p', 'proz-panel__intro', COPY.panelIntro(p.stylist_count, p.title)));

    var faq = el('div', 'proz-faq');
    COPY.faqs.forEach(function (f) {
      var d = el('details', 'proz-faq__row');
      d.appendChild(el('summary', null, f.q));
      d.appendChild(el('p', null, f.a));
      faq.appendChild(d);
    });
    inner.appendChild(faq);

    var list = el('ul', 'proz-list');
    p.stylists.forEach(function (s) {
      var li = el('li', 'proz-list__item');
      li.appendChild(avatar(s, 'lg'));
      var meta = el('div', 'proz-list__meta');
      meta.appendChild(el('span', 'proz-list__name', s.name));
      var sub = [s.salon, s.location].filter(Boolean).join(' · ');
      if (sub) meta.appendChild(el('span', 'proz-list__sub', sub));
      if (safeUrl(s.profile_url)) {
        var handle = el('a', 'proz-list__handle', s.handle);
        handle.href = s.profile_url;
        handle.target = '_blank';
        handle.rel = 'noopener';
        meta.appendChild(handle);
      } else {
        meta.appendChild(el('span', 'proz-list__handle', s.handle));
      }
      li.appendChild(meta);
      // One Instagram link per stylist: their latest IG post mentioning this product,
      // or their IG profile when they only posted Stories/TikToks
      if (safeUrl(s.latest_post_url)) {
        var post = el('a', 'proz-list__post', s.post_is_profile ? 'View profile' : 'View post');
        post.href = s.latest_post_url;
        post.target = '_blank';
        post.rel = 'noopener';
        li.appendChild(post);
      }
      list.appendChild(li);
    });
    inner.appendChild(list);
    inner.appendChild(el('p', 'proz-panel__foot', COPY.footnote(fmtMonth(generated))));

    dlg.appendChild(inner);
    // click on backdrop closes
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    return dlg;
  }

  var dataCache = {};
  function loadData(src) {
    if (!dataCache[src]) {
      dataCache[src] = fetch(src).then(function (r) {
        if (!r.ok) throw new Error('proz-choice.json ' + r.status);
        return r.json();
      });
      dataCache[src].catch(function () { delete dataCache[src]; });
    }
    return dataCache[src];
  }

  function mount(root) {
    if (root.hasAttribute('data-proz-mounted')) return;
    root.setAttribute('data-proz-mounted', '');
    var handle = root.getAttribute('data-product-handle');
    ASSET_BASE = root.getAttribute('data-asset-base') || '';
    loadData(root.getAttribute('data-src'))
      .then(function (data) {
        if (!document.contains(root)) return;
        var p = data.products && data.products[handle];
        if (!p || !p.show_badge) return; // product not in list or no stylist mentions -> no badge
        var panel = buildPanel(p, data.generated);
        // one badge per PDP: drop the panel left behind by a previous product
        document.querySelectorAll('.proz-panel').forEach(function (old) { old.remove(); });
        document.body.appendChild(panel);
        root.innerHTML = '';
        root.appendChild(buildBadge(p, function () { panel.showModal(); }));
        root.hidden = false;
      })
      .catch(function () { /* fail silently: PDP stays as-is */ });
  }

  function init() {
    document.querySelectorAll('[data-proz-choice]:not([data-proz-mounted])').forEach(mount);
  }

  // The variant picker swaps the whole <main> when a size is a separate product
  // (e.g. Full-size / Travel-size); scripts in the new markup don't run, so re-mount here.
  var queued = false;
  function watch() {
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(function () { queued = false; init(); }, 50); // not rAF: paused in background tabs
    }).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
  }

  function start() { init(); watch(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  window.ProzChoice = { init: init };
})();
